import { File } from "@/common/types/file";
import { LastReview } from "@/features/company/types/company.type";

export enum MaintenanceFiscalAssessmentEntryStatus {
  AwaitingEstablishmentDocuments = 'awaiting_establishment_documents',
  AwaitingManagementReview = 'awaiting_management_review',
}

export type MaintenanceFiscalAssessmentDocumentGroupData = {
  documents: {
    id: string;
    file: File;
    last_review: LastReview | undefined;
  }[];
  id: string;
  kind: 'activity' | 'piece';
}

export type MaintenanceFiscalAssessmentEntryData = {
  canceled_at: string | null;
  completed_at: string | null;
  document_groups: MaintenanceFiscalAssessmentDocumentGroupData[];
  id: string;
  process_started_at: string;
  status: MaintenanceFiscalAssessmentEntryStatus;
}
